import HttpService from '../../../core/rest/http.service';
import { stringToBoolean } from '../../../core/helpers/type-conversion.helper';
export async function loadSurveyList(filter) {
    let parameters = {};
    parameters = {
        published: stringToBoolean(filter.published),
        showSiteUrl: stringToBoolean(filter.showSiteUrl),
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/ankety";
    return HttpService.get(endpoint, parameters);
}
